export default {
  medications: {
    label: 'الأدوية',
    filterTitle: 'تصفية حسب الحالة',
    search: 'ابحث عن الأدوية',
    status: {
      draft: 'مشروع',
      active: 'نشيط',
      onHold: 'في الانتظار',
      cancelled: 'ألغيت',
      completed: 'منجز',
      enteredInError: 'دخلت خطأ',
      stopped: 'توقفت',
      unknown: 'مجهول',
    },
    intent: {
      proposal: 'اقتراح',
      plan: 'خطة',
      order: 'طلب',
      originalOrder: 'النظام الأصلي',
      reflexOrder: 'ترتيب منعكس',
      fillerOrder: 'طلب حشو',
      instanceOrder: 'أمر المثيل',
      option: 'اختيار',
    },
    priority: {
      routine: 'نمط',
      urgent: 'العاجلة',
      asap: 'في اسرع وقت ممكن',
      stat: 'ستات',
    },
    filter: {
      all: 'كل الحالات',
    },
    requests: {
      label: 'طلبات الأدوية',
      new: 'طلب دواء',
      view: 'مشاهدة ملف Medication',
      cancel: 'إلغاء الدواء',
      complete: 'دواء كامل',
      error: {
        unableToRequest: 'تعذر إنشاء طلب الدواء.',
        unableToComplete: 'تعذر إكمال طلب الدواء.',
        quantityRequired: 'الكمية مطلوبة.',
        unitRequired: 'الوحدة مطلوبة.',
      },
    },
    medication: {
      medication: 'دواء',
      for: 'إلى عن على',
      status: 'الحالة',
      intent: 'نوايا',
      priority: 'أفضلية',
      notes: 'ملاحظات',
      quantity: 'كمية',
      quantityValue: 'القيمة',
      quantityUnit: 'وحدة',
      requestedOn: 'طلبت في',
      requestedBy: 'بتوصية من',
      completedOn: 'اكتمل في',
      canceledOn: 'تم الإلغاء في',
      patient: 'صبور',
    },
  },
}
